export default "__VITE_ASSET__5028e474__"